import React, { useMemo } from "react";
import { McTable } from "@maersk-global/mds-react-wrapper/components-core/mc-table";

const TAG_BASE =
  "display:inline-block;padding:2px 10px;border-radius:10px;font-size:12px;font-weight:600;white-space:nowrap;line-height:16px;";

const TAG_STYLES = {
  success: `${TAG_BASE}background-color:var(--mds_brand_appearance_success_weak_background-color,#d4edda);color:var(--mds_brand_appearance_success_weak_on-background-color,#155724);`,
  error: `${TAG_BASE}background-color:var(--mds_brand_appearance_error_weak_background-color,#fcdde0);color:var(--mds_brand_appearance_error_weak_on-background-color,#370005);`,
  warning: `${TAG_BASE}background-color:var(--mds_brand_appearance_warning_weak_background-color,#fff3cd);color:var(--mds_brand_appearance_warning_weak_on-background-color,#856404);`,
  neutral: `${TAG_BASE}background-color:var(--mds_brand_appearance_neutral_weakest_background-color,#f7f7f7);color:var(--mds_brand_appearance_neutral_weakest_on-background-color,#616161);`,
};

function getPTaskStatusAppearance(status, eta) {
  const s = status?.toLowerCase();
  if (s === "done" || s === "closed") return "success";
  if (eta) {
    const due = new Date(eta);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (due < today) return "error";
  }
  return "warning";
}

const PTASK_BASE_URL = "https://maersk.service-now.com/nav_to.do?uri=task.do?sysparm_query=number=";

const PTASK_COLUMNS = [
  {
    id: "ptaskid",
    label: "PTask ID",
    noWrap: true,
    cellTemplate: (e) =>
      e.html`<a href="${PTASK_BASE_URL}${e.rowData.ptaskid}" target="_blank" rel="noopener noreferrer" style="color:#141414;text-decoration:underline;">${e.rowData.ptaskid}</a>`,
  },
  { id: "description", label: "Summary" },
  { id: "owners", label: "Assigned To" },
  { id: "assignment_group", label: "Assignment Group" },
  { id: "platformPortfolio", label: "Portfolio" },
  { id: "ptaskPlatform", label: "Platform" },
  { id: "ptaskProduct", label: "Product" },
  { id: "horizontalVerticalFix", label: "Fix Type" },
  {
    id: "status",
    label: "Status",
    noWrap: true,
    cellTemplate: (e) =>
      e.html`<span style="${TAG_STYLES[e.rowData.statusAppearance] || TAG_STYLES.neutral}">${e.rowData.status}</span>`,
  },
  { id: "eta", label: "Due Date", noWrap: true },
];

function PTaskSection({ data, images, requiredForModal }) {
  const tableData = useMemo(
    () =>
      (data || []).map((ticket, index) => ({
        id: index,
        ptaskid: ticket.ptaskid[0],
        description: ticket.description || "",
        owners:
          typeof ticket.owners === "string"
            ? ticket.owners
            : (ticket.owners || []).join(", "),
        assignment_group: ticket.assignment_group || "",
        platformPortfolio: ticket.platformPortfolio || "",
        ptaskPlatform: ticket.ptaskPlatform || "-",
        ptaskProduct: ticket.ptaskProduct || "-",
        horizontalVerticalFix: ticket.horizontalVerticalFix || "-",
        status: ticket.status || "",
        statusAppearance: getPTaskStatusAppearance(ticket.status, ticket.eta),
        eta: ticket.eta || "",
      })),
    [data]
  );

  return (
    <div style={{ padding: requiredForModal ? "20px" : undefined }}>
      {data && data.length > 0 ? (
        <>
          <McTable data={tableData} columns={PTASK_COLUMNS} fit="small" caption="PTask" />
          {images && images.length > 0 && (
            <div className="report-images">
              {images.map((image, index) => (
                <img key={index} alt={image.name} src={image.preview} />
              ))}
            </div>
          )}
        </>
      ) : null}
    </div>
  );
}

export default PTaskSection;
